<template>
  <div class="card border-0 cursor-pointer" @click="preview(content.id)">
    <div class="img-wrapper">
      <b-skeleton-img 
        v-if="!coverImageSrc" 
        no-aspect 
        height="350px" 
        class="skeleton-placeholder"
      ></b-skeleton-img>
      
      <img 
        v-else
        class="img-principal" 
        :src="coverImageSrc" 
        :alt="content.title"
      >
    </div>
    <div class="card-body p-4">
      <div class="titulo-principal">
        <b-skeleton v-if="!content.title" width="70%"></b-skeleton>
        <template v-else>{{ content.title }}</template>
      </div>

      <div class="container-info">
        <template v-if="!content.contentDate">          
          <b-skeleton width="100px"></b-skeleton>
        </template>
        <template v-else>
          <div class="badge-obrigatorio" v-if="content.mandatoryReading">
            Obrigatório
          </div>
          <div class="data-evento">
            {{ content.contentDate }}
          </div>
        </template>
      </div>

      <div class="text mt-4">
        <b-skeleton v-if="!content.coverCallout" width="100%"></b-skeleton>
        <b-skeleton v-if="!content.coverCallout" width="60%"></b-skeleton>
        
        <template v-else>
          {{ content.coverCallout }}
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import RoutesPaths from '../../../router/router-structure/routes-paths';
import coverImageMixin from '../mixins/coverImageMixin';

export default {
  name: 'MainTrainingCard',
  mixins: [coverImageMixin],
  props: {
    content: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      coverImageSrc: null
    }
  },
  watch: {
    content: {
      immediate: true,
      async handler(newObj) {        
        this._revokeCoverImages(); 
        this.coverImageSrc = null;

        if (newObj?.coverImageUrl) {          
          this.coverImageSrc = await this.loadCoverImage(newObj.coverImageUrl);
        }
      },
    },
  },  
  methods: {
    preview(id) {
      this.$router.push({
        path: RoutesPaths.connection.preview(id)
      });
    }
  }
}
</script>

<style scoped>
.titulo-principal {
  color: #343A40;
  font-family: "Trebuchet MS";
  font-size: 28px;
}

.img-principal {
  width: 100%;
  height: auto;    
  max-height: 350px; 
  object-fit: cover;
  display: block;
}

.cursor-pointer {
  cursor: pointer;
}

.badge-obrigatorio {
  display: inline-block;
  border-radius: 4px;
  background: #C0DB6D;
  padding: 3px 8px;
  color: #0E4025;
  font-family: "Trebuchet MS";
  font-size: 14px;
}

.container-info {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 10px;
}

.data-evento {
  font-family: "Trebuchet MS";
  font-size: 14px;
  color: #64696A;
}

.text {
  color: #343A40;
  font-family: "Trebuchet MS";
  font-size: 16px;
}

.card-body {
  padding: 1.25rem 0;  
}

.img-wrapper {
  width: 100%;
  min-height: 250px;
  background-color: #f8f9fa;
  overflow: hidden;  
  align-content: center;
}

</style>